import { getCountryFromLanguage } from "../../../core/service/BusinessLogicService"
import { getSessionVoyageurLang } from "../../../core/voyageurLanguage"
import useGetCities from "./hooks/useGetCities"
import useGetCountries from "./hooks/useGetCountries"
import useGetDepartments from "./hooks/useGetDepartments"

function useIdentityBloc({ tunnelData, values }) {
  const languageTag = getSessionVoyageurLang() || tunnelData?.lang || tunnelData?.data?.order?.orderLanguageTag
  const countryCodeFromLanguage = getCountryFromLanguage(languageTag)
  const countryCode = values?.identity?.birthCountry?.value || values?.identity?.birthCountry

  const { data: countries, isLoading: isLoadingCountries } = useGetCountries(
    tunnelData,
    countryCodeFromLanguage,
    languageTag
  )

  const { data: birthDepartmentOptions, isLoading: isLoadingBirthDepartmentOptions } = useGetDepartments(
    tunnelData,
    values,
    countryCodeFromLanguage,
    countryCode,
    languageTag
  )

  const { data: cities, isLoading: isLoadingCities } = useGetCities(
    tunnelData,
    values?.identity?.birthDepartment?.value
  )

  return {
    countries,
    isLoadingCountries,
    birthDepartmentOptions,
    isLoadingBirthDepartmentOptions,
    cities,
    isLoadingCities
  }
}

export default useIdentityBloc
